const getLocalState = state => state.pages.artist || {}

export const getArtistInfos = state => getLocalState(state).infos || {}
export const getArtistAlbums = state => (getLocalState(state).albums || {}).items || []



// WEBPACK FOOTER //
// ./src/pages/artist/artistSelectors.js